export default __webpack_public_path__ + "static/media/Resume.8f6c4d8a.pdf";